import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import VideoPlayer from './VideoPlayer';
import Navigation from './Navigation';
import { getLesson } from '../../services/lessonService';
import Quiz from './Quiz';

function ContentViewer() {
    const { lessonId } = useParams(); // Get lessonId from URL
    const [lesson, setLesson] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {
        const fetchLesson = async () => {
            setLoading(true);
            try {
                const response = await getLesson(lessonId);
                if (response.success) {
                    setLesson(response.data);
                } else {
                    setError(response.message);
                }
            } catch (err) {
                setError("An error occurred while fetching the lesson.");
            }
            setLoading(false);
        };

        fetchLesson();
    }, [lessonId]);

    const toggleDrawer = () => {
        setIsDrawerOpen((prev) => !prev);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {/* Navbar */}
            <Navbar courseTitle={lesson ? lesson.course.title : 'Loading...'} toggleDrawer={toggleDrawer} />

            {/* Content */}
            <Box
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                }}
            >
                {/* Sidebar */}
                <Box
                    sx={{
                        width: '320', // Fixed width for the sidebar
                        flexShrink: 0, // Prevent shrinking when space is constrained
                        borderRight: '1px solid #ddd', // Optional: add a border for visual separation
                        backgroundColor: '#f8fafc', // Background for the sidebar
                        overflowY: 'auto', // Enable scrolling for long content
                    }}
                >
                    <Sidebar
                        modules={lesson?.courseOutline || []} // Pass API courseOutline as modules
                        isDrawerOpen={isDrawerOpen}
                        toggleDrawer={toggleDrawer}
                        courseSlug={lesson?.course?.slug}
                    />
                </Box>

                {/* Main Content */}
                <Box
                    sx={{
                        flexGrow: 1
                    }}
                >
                    {lesson && (
                        <>
                            {lesson.type == 'video' ? (
                                <>
                                    <VideoPlayer lesson={lesson} />
                                    <Navigation lesson={lesson} />
                                </>
                            ) : lesson.type == 'quiz' ? (
                                <Quiz lesson={lesson} />
                            ) : (
                                <Box sx={{ textAlign: 'center', p: 4, color: 'red' }}>
                                    Content type not supported
                                </Box>
                            )}
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
}

export default ContentViewer;
